<template>
    <div class="page-layout blank contacts-manage mb-10 mlr-0">
        <div v-if="(ajaxCallinprogress || list_loader)" class="d-flex align-items-center justify-content-center" style="height: 100vh !important;">
            <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/> -->
            <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
        </div>
        <div v-else-if="!ajaxCallinprogress && is_ticket_not_found">
            <h1 class="fs-14 text-danger text-center py-3">
                <div class="fw-500">No Ticket details found...</div>
                <img src="/static/images/not_found.svg" />
            </h1>
        </div>
        <div v-else class="general-section">
            <div class="mb-5">
                <div class="header-detail-view-new mt-2 px-3 py-2">
                    <div>
                        <span class="pl-1">Ticket #{{general_details.ticket_number}}</span>
                        <!-- <div class="text-secondary fw-500 pl-10 text-capitalize">{{general_details.subject}}</div> -->
                    </div>
                    <div class="d-flex">
                            <div class="mr-2">
                                <el-popover
                                    placement="bottom"
                                    trigger="click">
                                    <div class="fs-14 fw-500">
                                        <div class="align-items-center text-center">
                                            <span class="header-text">Eisenhower Matrix</span>
                                        </div>
                                        <div class="d-flex align-items-center mt-3">
                                            <div class="quadrant top-left" :class="{'active-matrix' : priority_of_ticket.imp_not_urgent}">
                                                Important <br>- Not Urgent
                                            </div>
                                            <div class="quadrant top-right" :class="{'active-matrix' : priority_of_ticket.imp_urgent}">
                                                Important <br>- Urgent
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="quadrant bottom-left" :class="{'active-matrix' : priority_of_ticket.not_imp_urgent}">
                                                Not Important <br>- Urgent
                                            </div>
                                            <div class="quadrant bottom-right" :class="{'active-matrix' : priority_of_ticket.not_imp_not_urgent}">
                                                Not Important <br>- Not Urgent
                                            </div>
                                        </div>
                                    </div>
                                    <el-button slot="reference" class="text-secondary fw-500 fs-14 eisenhower-button">
                                        <i class="icon icon-eye text-white pointer vertical-align-middle-icon fs-14"></i> Eisenhower Matrix
                                    </el-button>
                                </el-popover>
                            </div>
                            <div>
                                <button class="btn btn-smm btn-default text-white btn-success-border-radius btn-open-status-newtheme btn-reopen-newtheme" :disabled="general_details.ticket_template.template_type == 'multi_part'" @click="changeStatus()">Re-Open</button>
                            </div>
                        </div>
                    </div>
                <!-- <div class="d-flex justify-content-between pt-5 ml-5 mr-5">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="text-secondary fw-500">Ticket #{{general_details.ticket_number}}</div>
                        <div class="text-secondary fw-500 pl-10 text-capitalize">{{general_details.subject}}</div>
                    </div>
                    <button class="btn btn-secondary btn-smm" :disabled="general_details.ticket_template.template_type == 'multi_part'" @click="changeStatus()">Re-Open</button>
                </div> -->
                <div class="box-shadow mt-2">
                    <div class="capture-image d-flex align-items-center p-2 px-4">
                        <span class="text-new-header-black fw-600 mr-3" style="width: max-content;min-width: max-content;">General Details</span>
                        <div class="inner-line-hr w-100"></div>
                        <img v-if="show_hide_general_details" class="pointer capture-image-rotate" @click="showHideGeneralDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                        <img v-else class="pointer capture-image-rotate" @click="showHideGeneralDetails" src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                    </div>

                    <div v-if="show_hide_general_details" class="px-2">
                        <div class="row mt-3">
                            <div class="col-lg-12 col-md-12 col-sm-12 d-flex">
                                <div class="fw-500 pr-26 text-black-shade w-250px">Assigned To:</div> 
                                <div class="fw-400 overflowing-text text-capitalize" :title="general_details.assigned_to">
                                    <span>{{general_details.assigned_to || '-'}}</span></div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12  d-flex mt-3 ">
                                <div class="fw-500 pr-23 text-black-shade w-250px">Ticket Subject:</div> 
                                <div class="fw-400 overflowing-text text-capitalize" :title="general_details.subject">
                                    <span>{{general_details.subject || '-'}}</span></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                <div class="fw-500 pr-35 text-black-shade w-250px">Author:</div>
                                <div class="fw-400 overflowing-text text-capitalize" :title="general_details.created_by.name">
                                    <span>{{general_details.created_by.name || '-'}}</span></div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                <div class="fw-500 pr-1 text-black-shade w-250px">Date and Time of Creation:</div>
                                <div class="fw-400 d-flex align-items-center">
                                    <img src="/static/images/new-theme2024/calender_black.svg" alt="calendar-icon"/>
                                    <span class="ml-1">
                                        {{general_details.creation_date.date.replaceAll('-','/') || '-'}}
                                    </span>
                                    <i class="iconly-Curved-TimeCircle text-black-shade ml-2"></i>
                                    <span class="ml-1">
                                        {{general_details.creation_date.time || '-'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                <div class="fw-500 pr-36 text-black-shade w-250px">Status:</div>
                                <div class="fw-400 overflowing-text text-capitalize">
                                    <span>{{general_details.status|| '-'}}</span>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                <div class="fw-500 pr-19 text-black-shade w-250px">Template Name:</div> 
                                <div class="fw-400 text-capitalize">
                                    <span>
                                        {{general_details.ticket_template.name|| '-'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-122 col-sm-1 d-flex mt-3">
                                <div class="fw-500 pr-22 text-black-shade w-250px">Template Type:</div> 
                                <div class="fw-400 description-content">
                                    <span v-if="general_details.ticket_template.template_type" class="text-capitalize" v-html="general_details.ticket_template.template_type.replace(/_/g, ' ')"></span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3 mb-2">
                                <div class="fw-500 pr-28 text-black-shade w-250px">Description:</div> 
                                <div class="fw-400 description-content">
                                    <pre class="fs-14" style="overflow: hidden;word-break: break-all;white-space: normal;" v-if="general_details.description" v-html="general_details.description"></pre>
                                    <span v-else>-</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="mt-5 mb-3">
                    <div class="box-blue-header d-flex align-items-center justify-content-between p-3 box-blue-header-parent">
                        <span class="text-white fw-500 pl-1">General Details</span>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Assigned To :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="general_details.assigned_to">
                                <span>{{general_details.assigned_to || '-'}}</span></div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Ticket Subject :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="general_details.subject">
                                <span>{{general_details.subject || '-'}}</span></div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Author :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="general_details.created_by.name">
                                <span>{{general_details.created_by.name || '-'}}</span></div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Date and Time of Creation :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/calendar.svg" alt="">
                                <span class="ml-1">
                                    {{general_details.creation_date.date.replaceAll('-','/') || '-'}}
                                </span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/clock.svg" class="ml-2" alt="">
                                <span class="ml-1">
                                    {{general_details.creation_date.time || '-'}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pl-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Status:</div> <br>
                            <div class="fw-500 text-secondary d-inline-block text-capitalize">{{general_details.status|| '-'}}</div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 pl-0">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Template Name:</div> <br>
                            <div class="fw-500 text-secondary d-inline-block text-capitalize">
                                <span>
                                    {{general_details.ticket_template.name|| '-'}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Template Type:</div> <br>
                            <div class="fw-500 text-secondary d-inline-block description-content text-capitalize">
                                <span v-if="general_details.ticket_template.template_type" v-html="general_details.ticket_template.template_type.replace(/_/g, ' ')"></span>
                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Description:</div> <br>
                            <div class="fw-500 text-secondary description-content">
                                <span style="word-break: break-all" v-if="general_details.description" v-html="general_details.description"></span>
                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="mt-5 box-shadow pb-3 mb-3">
                    <div class="capture-image d-flex align-items-center p-2 px-4">
                        <span class="text-new-header-black fw-600 mr-3" style="width: max-content;min-width: max-content;">Ticket Details</span>
                        <div class="inner-line-hr w-100"></div>
                        <img v-if="show_hide_tickets_details" class="pointer capture-image-rotate" @click="showHideTicketsDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                        <img v-else class="pointer capture-image-rotate" @click="showHideTicketsDetails" src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                    </div>
                    <!-- <div class="box-blue-header d-flex align-items-center justify-content-between p-3 box-blue-header-parent">
                        <span class="text-white fw-500 pl-1">Ticket Details</span>
                        <span v-if="general_details.is_editable">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/pencil_bg_white.svg" alt="" style="width: 25px;cursor:pointer" @click="showEditBaseTemplate()">
                        </span>
                    </div> -->
                    <div v-if="show_hide_tickets_details">
                    <div class="details-checks" v-if="template_type == 'default'">
                        <div class="row pt-3 pl-5 pr-5 pb-2">
                            <span class="col-lg-12 col-md-12 col-sm-12  pb-2" v-for="(dynamic_data, index) in dynamic_template_data" :key="index">
                                <div v-if="dynamic_data.type == 'long_answer'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text text-capitalize" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <div class="fw-400 text-black overflowing-text text-capitalize" :title="dynamic_data.answer">
                                    <span>{{dynamic_data.answer || '-'}}</span></div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'short_answer'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text text-capitalize" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <div class="fw-400 text-black overflowing-text text-capitalize" :title="dynamic_data.answer">
                                    <span>{{dynamic_data.answer || '-'}}</span></div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'date'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <span v-if="dynamic_data.answer.length == 0">-</span>
                                    <div v-else class="fw-400 text-black ">
                                        <span><img src="/static/images/new-theme2024/calender_black.svg" width="22" alt=""></span>
                                        {{dynamic_data.answer}}</div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'time'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <span v-if="dynamic_data.answer.length == 0">-</span>
                                    <div v-else class="fw-400 text-black ">
                                        <span><img src="/static/images/new-theme2024/time-line.svg" alt=""></span>
                                        {{dynamic_data.answer}}</div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'date_time'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <span v-if="dynamic_data.answer.length == 0">-</span>
                                    <div v-else class="fw-400 text-black ">
                                        <span><img src="/static/images/new-theme2024/calender_black.svg" width="22" alt=""></span>
                                        {{dynamic_data.answer.slice(0, 10)}}
                                        <span class="ml-2"><img src="/static/images/new-theme2024/time-line.svg" alt=""></span>
                                        {{dynamic_data.answer.slice(11, )}}
                                    </div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'radio_button'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <div class="fw-400 text-black overflowing-text text-capitalize" :title="dynamic_data.answer">
                                    <span v-if="dynamic_data.answer.length == 0">-</span>
                                    <span v-else>{{dynamic_data.answer}}</span></div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == false" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <div class="fw-400 text-black overflowing-text text-capitalize" :title="dynamic_data.answer">
                                    <span>{{dynamic_data.answer || '-'}}</span></div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == true" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <div class="fw-400 text-black overflowing-text text-capitalize" :title="dynamic_data.answer.name">
                                    <span>{{dynamic_data.answer.name || '-'}}</span></div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'check_box'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <span v-if="dynamic_data.answer.length == 0">-</span>
                                    <div v-else class="fw-400 text-black  text-capitalize" v-for="(data, index) in dynamic_data.answer" :key='index'>{{data}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                                </div>
                                <div v-else-if="dynamic_data.type == 'tag'" class=" d-flex">
                                    <div class="fw-500 w-250px text-black overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> 
                                    <div v-if="dynamic_data.answer.length == 0">-</div>
                                    <div v-else class="fw-400 text-black  text-capitalize" v-for="(tag_name, index) in dynamic_data.answer" :key='index'>{{tag_name}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                                </div>
                                <div class="mt-3" v-if="dynamic_data.hasOwnProperty('add_attachments') && dynamic_data.add_attachments">
                                    <div v-if="dynamic_data.hasOwnProperty('attachments')">
                                        <div v-if="dynamic_data.attachments.length == 0">
                                            <div class="fw-500 fs-15px mt-3">Attachment 2</div>
                                            <div class="font-weight-bold fs-15px mt-2 pb-3">No Attachment Added</div>
                                        </div>
                                        <div v-else class="mt-3  ">
                                            <!-- <span class="fw-500  fs-15px">Attachment</span> -->
                                            <div v-for="(attachment, att_index) in dynamic_data.attachments" :key="att_index">
                                                <div class="d-flex flex-wrap">
                                                    <div class="d-flex justify-content-between align-items-center w-50">
                                                        <div class="d-flex align-items-center pt-3 pb-3" v-if="attachment.hasOwnProperty('url')">
                                                            <span  class="px-2" >
                                                                <img src="/static/images/storage.svg" width="20">
                                                                <!-- <img class="att-img pointer" v-if="attachment.url.endsWith('.pdf')"
                                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.zip') || attachment.url.endsWith('.ZIP')" 
                                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ppt')" 
                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.pptx')" 
                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.csv') || attachment.url.endsWith('.CSV')" 
                                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ODS') || attachment.url.endsWith('.ods')" 
                                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.svg')"
                                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.avi') || attachment.name.endsWith('.flv') || attachment.name.endsWith('.mpg') || attachment.name.endsWith('.mpeg') || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.wav') || attachment.name.endsWith('.wmv') || attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')"
                                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                                                <img class="att-img pointer" v-else :src="attachment.url" alt="">
                                                                <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                                            </span>
                                                            <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachment.name">{{attachment.name}}</div>
                                                            <!-- <div v-if="attachment.hasOwnProperty('url')">
                                                                <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                                    <i class="icon icon-download"></i>
                                                                </a>
                                                            </div> -->
                                                            <div>
                                                                    <img src="/static/images/new-theme2024/eye-line.svg" width="20" class="mr-2 pointer" @click="previewImage(attachment)">
                                                                </div>
                                                        </div>
                                                        <div v-else>
                                                            -
                                                        </div>
                                                        <!-- <div v-if="attachment.hasOwnProperty('url')">
                                                            <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                                <i class="icon icon-download"></i>
                                                            </a>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                    <div v-if="template_type == 'multi_part'">
                        <div class="details-checks" v-for="(part, part_index) in dynamic_template_data" :key="part_index">
                            <div class="infoHeader">
                                <!-- <div class="descriptionheader px-2">
                                    <div class="description-text-header-left">
                                        <h5 class="font-weight-bold text-black whiteSpace">{{ part.part_name.split('').length > 1 ?  part.part_name[0].toUpperCase() +''+ part.part_name.slice(1,) : part.part_name[0].toUpperCase()}}</h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <span class="collapse-addon" v-if="part.show">
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(part)" alt="" style="top: 9px !important;transition:0.5s">
                                        </span>
                                        <span class="collapse-addon" v-else>
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(part)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                        </span>
                                    </div>
                                </div> -->
                                    <div class="capture-image d-flex align-items-center p-2 px-4">
                                    <span class="text-new-header-black fw-600 mr-3" style="width: max-content;min-width: max-content;">{{ part.part_name.split('').length > 1 ?  part.part_name[0].toUpperCase() +''+ part.part_name.slice(1,) : part.part_name[0].toUpperCase()}}</span>
                                    <div class="inner-line-hr w-100"></div>
                                    <img v-if="show_hide_multi_details" class="pointer capture-image-rotate" @click="showHideMultiDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                                    <img v-else class="pointer capture-image-rotate" @click="showHideMultiDetails" src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                                </div>
                            </div>
                            <div class="row pt-3 pl-5 pr-5 pb-2" v-if="show_hide_multi_details">
                                <span class="col-lg-12 col-md-12 col-sm-12  pb-2 " v-for="(dynamic_data, index) in part.parts_data" :key="index">
                                    <div class="d-flex">
                                    <div class="fw-500 w-250px text-black   overflowing-text" :title="dynamic_data.name">{{ dynamic_data.name.split('').length > 1 ?  dynamic_data.name[0].toUpperCase() +''+ dynamic_data.name.slice(1,) : dynamic_data.name[0].toUpperCase()}}</div> <br>
                                    <div v-if="dynamic_data.type == 'long_answer'">
                                        <div class="fw-400 text-black   overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'short_answer'">
                                        <div class="fw-400 text-black   overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'date'">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="fw-400 text-black  text-capitalize">
                                            <span><img src="/static/images/new-theme2024/calender_black.svg" width="22" alt=""></span>
                                            {{dynamic_data.answer}}</div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'time'">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="fw-400 text-black  text-capitalize">
                                            <span><img src="/static/images/new-theme2024/time-line.svg" width="22" alt=""></span>
                                            {{dynamic_data.answer}}</div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'radio_button'">
                                        <div class="fw-400 text-black   overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <span v-else>{{dynamic_data.answer}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == false">
                                        <div class="fw-400 text-black   overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == true">
                                        <div class="fw-400 text-black   overflowing-text text-capitalize" :title="dynamic_data.answer.name">
                                        <span>{{dynamic_data.answer.name || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'check_box'">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="fw-400 text-black " v-for="(data, index) in dynamic_data.answer" :key='index'>{{data}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'tag'">
                                        <div v-if="dynamic_data.answer.length == 0">-</div>
                                        <div v-else class="fw-400 text-black  text-capitalize" v-for="(tag_name, index) in dynamic_data.answer" :key='index'>{{tag_name}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'date_time'">
                                        <div class="fw-400 text-black ">
                                            <span><img src="/static/images/new-theme2024/calender_black.svg" width="22" alt=""></span>
                                            {{dynamic_data.answer.slice(0, 10)}}
                                            <span class="ml-2"><img src="/static/images/new-theme2024/time-line.svg" width="22" alt=""></span>
                                            {{dynamic_data.answer.slice(11, )}}
                                        </div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'location'">
                                        <div class="fw-400 text-black   overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                </div>
                                    <div class="mt-3" v-if="dynamic_data.hasOwnProperty('add_attachments') && dynamic_data.add_attachments">
                                        <div v-if="dynamic_data.hasOwnProperty('attachments')">
                                            <div v-if="dynamic_data.attachments.length == 0">
                                                <div class="fw-500 fs-15px mt-3">Attachment</div>
                                                <div class="font-weight-bold fs-15px mt-2 pb-3">No Attachment Added</div>
                                            </div>
                                            <div v-else class="mt-3">
                                                <!-- <span class="fw-500 fs-15px">Attachment</span> -->
                                                <div v-for="(attachment, att_index) in dynamic_data.attachments" :key="att_index">
                                                    <div class="d-flex flex-wrap">
                                                        <div class="d-flex justify-content-between align-items-center w-50">
                                                            <div class="d-flex align-items-center pt-3 pb-3" v-if="attachment.hasOwnProperty('url')">
                                                                <span  class="px-2">
                                                                    <img src="/static/images/storage.svg" width="20">
                                                                    <!-- <img class="att-img pointer" v-if="attachment.url.endsWith('.pdf')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.zip') || attachment.url.endsWith('.ZIP')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ppt')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.pptx')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.csv') || attachment.url.endsWith('.CSV')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ODS') || attachment.url.endsWith('.ods')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.svg')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.avi') || attachment.name.endsWith('.flv') || attachment.name.endsWith('.mpg') || attachment.name.endsWith('.mpeg') || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.wav') || attachment.name.endsWith('.wmv') || attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')"
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                                                    <img class="att-img pointer" v-else :src="attachment.url" alt="">
                                                                    <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                                                </span>
                                                                <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachment.name">{{attachment.name}}</div>
                                                                <!-- <div v-if="attachment.hasOwnProperty('url')">
                                                                    <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                                        <i class="icon icon-download"></i>
                                                                    </a>
                                                                </div> -->
                                                                <div>
                                                                    <img src="/static/images/new-theme2024/eye-line.svg" width="20" class="mr-2 pointer" @click="previewImage(attachment)">
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                -
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="mt-5 mb-3" v-if="part.attach_files.length > 0 && part.show">
                                <div class="infoHeader">
                                    <div class="descriptionheader px-2">
                                        <div class="description-text-header-left">
                                            <span class="font-weight-bold fs-15 text-black whiteSpace">Attachments</span>
                                        </div>
                                        <div class="description-text-header-right"></div>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap">
                                    <div class="d-flex justify-content-between align-items-center px-3 w-50" v-for="attachments in part.attach_files" :key="attachments.url">
                                        <div class="d-flex align-items-center mt-2" v-if="attachments.hasOwnProperty('url')">
                                            <span  class="mr-3 pointer" @click="previewImage(attachments)">
                                                <img src="/static/images/storage.svg" width="20">
                                                <!-- <img class="att-img pointer" v-if="attachments.url.endsWith('.pdf')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.zip') || attachments.url.endsWith('.ZIP')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ppt')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.pptx')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.csv') || attachments.url.endsWith('.CSV')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ODS') || attachments.url.endsWith('.ods')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.avi') || attachments.name.endsWith('.flv') || attachments.name.endsWith('.mpg') || attachments.name.endsWith('.mpeg') || attachments.name.endsWith('.mp4') || attachments.name.endsWith('.wav') || attachments.name.endsWith('.wmv') || attachments.name.endsWith('.MOV') || attachments.name.endsWith('.mov')"
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />

                                                <img class="att-img pointer" v-else-if="attachment.url.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                                <img class="att-img pointer" v-else :src="attachments.url" alt=""> -->
                                                <!-- <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                            </span>
                                            <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachments.name">{{attachments.name}}</div>
                                            <div v-if="attachments.hasOwnProperty('url')">
                                                <a class="pointer" :href="attachments.url" download style="text-decoration: none;">
                                                    <i class="icon icon-download"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <div class="mt-5 mb-3 box-shadow"  v-if="template_type == 'default'">
                    <div v-if="general_details.attach_files.length == 0">
                        <div class="capture-image d-flex align-items-center p-2 px-4">
                        <span class="text-new-header-black fw-600 mr-3" style="width: max-content;min-width: max-content;">Attachment</span>
                        <div class="inner-line-hr w-100"></div>
                        <img v-if="show_hide_attachment_details" class="pointer capture-image-rotate" @click="showHideAttachmentDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                        <img v-else class="pointer capture-image-rotate" @click="showHideAttachmentDetails" src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                    </div>
                        <div class="font-weight-bold fs-15px mt-2 pb-3 ml-2">No Attachment Added</div>
                    </div>
                    <div v-else class="mt-3">
                        <div class="capture-image d-flex align-items-center p-2 px-4">
                        <span class="text-new-header-black fw-600 mr-3" style="width: max-content;min-width: max-content;">Attachment</span>
                        <div class="inner-line-hr w-100"></div>
                        <img v-if="show_hide_attachment_details" class="pointer capture-image-rotate" @click="showHideAttachmentDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                        <img v-else class="pointer capture-image-rotate" @click="showHideAttachmentDetails" src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                    </div>
                        <!-- <span class="fw-500 fs-15px" >Attachment</span> -->
                        <div class="d-flex flex-wrap" v-if="show_hide_attachment_details">
                            <div class="d-flex justify-content-between align-items-center px-3 w-50 mb-3" v-for="attachments in general_details.attach_files" :key="attachments.url">
                                <div class="d-flex align-items-center p-3" v-if="attachments.hasOwnProperty('url')">
                                    <span  class="px-2">
                                        <img src="/static/images/storage.svg" width="20">
                                        <!-- <img class="att-img pointer" v-if="attachments.url.endsWith('.pdf')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.zip') || attachments.url.endsWith('.ZIP')" 
                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ppt')" 
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.pptx')" 
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.csv') || attachments.url.endsWith('.CSV')" 
                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ODS') || attachments.url.endsWith('.ods')" 
                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.svg')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.avi') || attachments.name.endsWith('.flv') || attachments.name.endsWith('.mpg') || attachments.name.endsWith('.mpeg') || attachments.name.endsWith('.mp4') || attachments.name.endsWith('.wav') || attachments.name.endsWith('.wmv') || attachments.name.endsWith('.MOV') || attachments.name.endsWith('.mov')"
                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                        <img class="att-img pointer" v-else :src="attachments.url" alt="">
                                        <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                    </span>
                                    <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachments.name">{{attachments.name}}</div>
                                    <div>
                                        <img src="/static/images/new-theme2024/eye-line.svg" width="20" class="mr-2 pointer" @click="previewImage(attachments)">
                                    </div>
                                    <!-- <div v-if="attachments.hasOwnProperty('url')">
                                        <a class="pointer" :href="attachments.url" download style="text-decoration: none;">
                                            <i class="icon icon-download"></i>
                                        </a>
                                    </div> -->
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-with-blue-border mt-5 mb-3" v-if="isTechnician">
                    <div class="d-flex justify-content-between pb-2 fs-15" style="background:#00448b;">
                        <span class="text-white fw-500 pl-1">Technician Visit</span>
                    </div>
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">Visit Details</div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black">Scheduled Start Date and Time</div>
                            <div class="fw-500 text-secondary d-flex align-items-center" v-if="template_data_TV.scheduled_start_date_and_time">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/calendar.svg" alt="" style="width: 20px;">
                                <span class="pl-2 pr-2">{{template_data_TV.scheduled_start_date_and_time.date || '-'}}</span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/clock.svg" alt="" style="width: 20px;">
                                <span class="pl-2">{{template_data_TV.scheduled_start_date_and_time.time || '-'}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black">Scheduled End Date and Time</div>
                            <div class="fw-500 text-secondary d-flex align-items-center" v-if="template_data_TV.scheduled_end_date_and_time">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/calendar.svg" alt="" style="width: 20px;">
                                <span class="pl-2 pr-2">{{template_data_TV.scheduled_end_date_and_time.date}}</span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/clock.svg" alt="" style="width: 20px;">
                                <span class="pl-2">{{template_data_TV.scheduled_end_date_and_time.time}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12" v-if="show_priority">
                            <div class="fw-400 pt-2 pb-2 text-black">Priority</div>
                            <button class="btn btn-smm text-white" :class="{'btn-orange':template_data_TV.priority == 'Medium','btn-danger':template_data_TV.priority == 'High','btn-success':template_data_TV.priority == 'Low'}">{{template_data_TV.priority}}</button>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black">Notify Before</div>
                             <div class="text-black fw-500" style="text-transform: capitalize;" v-for="(item,index) in template_data_TV.notify_before" :key="index">{{item.value}} {{item.period}}</div>
                        </div>
                    </div>
                </div>
                <div class="box-with-blue-border mt-5 mb-3" v-if="isSPR">
                    <div class="d-flex justify-content-between pb-2 fs-15" style="background:#00448b;">
                        <span class="text-white fw-500 pl-1">Spare Part Requirement</span>
                    </div>
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">{{product_naming_convention}} Details </div>
                    <div class="fw-500 pl-5 pr-2 pt-2 pb-2">{{product_naming_convention}} Name</div>
                    <div class="fw-500 pl-5 pr-2 text-secondary" v-if="template_data_SPR.product_id">{{template_data_SPR.product_id.name}}</div>
                    <div class="fw-500 pl-5 pr-2 pt-2 pb-2">Required Spare Parts</div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-4 col-md-4 col-sm-4" v-for="(item,index) in template_data_SPR.spare_parts" :key="index">
                            <div class="productBox">
                                <div class="fw-500 p-2">Part Name</div>
                                <div class="fw-500 fs-16 pl-2 text-secondary">{{item.name}}</div>
                                <div class="fw-500 p-2">Date and Time of Purchase</div>
                                <div class="fw-500 pl-2 text-secondary d-flex align-items-center" v-if="item.date_and_time_of_purchase">
                                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/calendar.svg" alt="" style="width: 20px;">
                                    <span class="pl-2 pr-2">{{item.date_and_time_of_purchase.date || '-'}}</span>
                                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/clock.svg" alt="" style="width: 20px;">
                                    <span class="pl-2">{{item.date_and_time_of_purchase.time || '-'}}</span>
                                </div>
                                <div class="d-flex justify-content-end mt-2">
                                    <span class="warranty" v-if="item.is_product_covered_under_warranty">Within Warranty</span>
                                    <span class="out_warranty" v-else>Out Of Warranty</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-12 col-md-12 col-sm-12" v-if="show_priority">
                            <div class="fw-500 w-250px text-black">Priority</div>
                            <button class="btn btn-smm text-white" :class="{'btn-orange':template_data_SPR.priority == 'Medium','btn-danger':template_data_SPR.priority == 'High','btn-success':template_data_SPR.priority == 'Low'}">{{template_data_SPR.priority}}</button>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 pt-2">
                            <div class="fw-500 w-250px  text-black">Delivery Address</div>
                            <div class="fw-400 text-black">{{template_data_SPR.delivery_address}}</div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-500 w-250px  text-black">Due Date and Time</div>
                            <div class="fw-400 text-black d-flex align-items-center" v-if="template_data_SPR.due_date_and_time">
                                <img src="/static/images/new-theme2024/calender_black.svg" alt="" style="width: 22px;">
                                <span class="pl-2 pr-2">{{template_data_SPR.due_date_and_time.date || '-'}}</span>
                                <img src="/static/images/new-theme2024/time-line.svg" alt="" style="width: 22px;">
                                <span class="pl-2">{{template_data_SPR.due_date_and_time.time || '-'}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#00448b;"></div>
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">Costing</div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Assigned Employee</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPR.costing">{{template_data_SPR.costing.assigned_employee}}</div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Billing Rate</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPR.costing">{{template_data_SPR.costing.billing_rate_per_hour}}</div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Man Hours per Person</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPR.costing">{{template_data_SPR.costing.man_hours}}</div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Estimated Cost</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPR.costing">{{template_data_SPR.costing.estimated_cost}}</div>
                        </div>
                    </div>
                </div>
                <div class="box-with-blue-border mt-5 mb-3" v-if="isSPD">
                    <div class="d-flex justify-content-between pb-2 fs-15" style="background:#00448b;">
                        <span class="text-white fw-500 pl-1">Spare Part Delivery</span>
                    </div>
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">Delivery Details </div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black">Delivery Start Date and Time</div>
                            <div class="fw-500 text-secondary d-flex align-items-center" v-if="template_data_SPD.delivery_start_date_and_time">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/calendar.svg" alt="" style="width: 20px;">
                                <span class="pl-2 pr-2">{{template_data_SPD.delivery_start_date_and_time.date || '-'}}</span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/clock.svg" alt="" style="width: 20px;">
                                <span class="pl-2">{{template_data_SPD.delivery_start_date_and_time.time || '-'}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black">Delivery End Date and Time</div>
                            <div class="fw-500 text-secondary d-flex align-items-center" v-if="template_data_SPD.delivery_end_date_and_time">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/calendar.svg" alt="" style="width: 20px;">
                                <span class="pl-2 pr-2">{{template_data_SPD.delivery_end_date_and_time.date || '-'}}</span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/clock.svg" alt="" style="width: 20px;">
                                <span class="pl-2">{{template_data_SPD.delivery_end_date_and_time.time || '-'}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12" v-if="show_priority">
                            <div class="fw-400 pt-2 pb-2 text-black">Priority</div>
                            <button class="btn btn-smm text-white" :class="{'btn-orange':template_data_SPD.priority == 'Medium','btn-danger':template_data_SPD.priority == 'High','btn-success':template_data_SPD.priority == 'Low'}">{{template_data_SPD.priority}}</button>
                        </div>
                    </div>
                </div>
                <div class="box-with-blue-border mt-5 mb-3" v-if="isSPI">
                    <div class="d-flex justify-content-between pb-2 fs-15" style="background:#00448b;">
                        <span class="text-white fw-500 pl-1">Spare Part Installation</span>
                    </div>
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">Installation Details </div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black">Installation Start Date and Time</div>
                            <div class="fw-500 text-secondary d-flex align-items-center" v-if="template_data_SPI.installation_start_date_and_time">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/calendar.svg" alt="" style="width: 20px;">
                                <span class="pl-2 pr-2">{{template_data_SPI.installation_start_date_and_time.date || '-'}}</span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/clock.svg" alt="" style="width: 20px;">
                                <span class="pl-2">{{template_data_SPI.installation_start_date_and_time.time || '-'}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black">Installation End Date and Time</div>
                            <div class="fw-500 text-secondary d-flex align-items-center" v-if="template_data_SPI.installation_end_date_and_time">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/calendar.svg" alt="" style="width: 20px;">
                                <span class="pl-2 pr-2">{{template_data_SPI.installation_end_date_and_time.date || '-'}}</span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/clock.svg" alt="" style="width: 20px;">
                                <span class="pl-2">{{template_data_SPI.installation_end_date_and_time.time || '-'}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12" v-if="show_priority">
                            <div class="fw-400 pt-2 pb-2 text-black">Priority</div>
                            <button class="btn btn-smm text-white" :class="{'btn-orange':template_data_SPI.priority == 'Medium','btn-danger':template_data_SPI.priority == 'High','btn-success':template_data_SPI.priority == 'Low'}">{{template_data_SPI.priority}}</button>
                        </div>
                    </div>
                    <div class="pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#00448b;"></div>
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">Costing</div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Assigned Employee</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPI.costing">{{template_data_SPI.costing.assigned_employee}}</div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Billing Rate</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPI.costing">{{template_data_SPI.costing.billing_rate_per_hour}}</div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pb-2">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Man Hours per Person</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPI.costing">{{template_data_SPI.costing.man_hours}}</div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="fw-400 pt-2 pb-2 text-black">Estimated Cost</div>
                            <div class="fw-500 text-secondary" v-if="template_data_SPI.costing">{{template_data_SPI.costing.estimated_cost}}</div>
                        </div>
                    </div>
                </div>
                <div class="box-with-blue-border mt-5 mb-3" v-if="isQuotation">
                    <div class="pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#00448b;"></div>
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">Quotation</div>
                    <div class="d-flex">
                        <div class="col-lg-3 col-md-3 col-sm-3" v-for="(part,index) in quotation_details.spare_parts" :key="index">
                            <div class="pt-2 fw-500">Part {{index+1}} </div>
                            <div class="d-flex pt-2 pb-2 justify-content-between">
                                <span class="text-secondary fw-500">{{part.name}}</span>
                                <span class="text-secondary fw-500">${{part.cost}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="pt-2 pb-2 fw-500">Total Cost</div>
                        <div class="text-secondary pb-3 fw-500">${{quotation_details.total_cost}}</div>
                    </div>
                    <div class="pl-5 pr-2 pt-3 pb-5 fw-500 d-flex justify-content-end" style="background:#00448b;">
                        <button class="btn btn-white btn-smm" style="border-radius: 12px !important;background: #fff !important;" v-if="general_details.hasOwnProperty('all_product_covered_under_warranty') && !general_details.all_product_covered_under_warranty && general_details.send_quotation_as_an_email" @click="sendQuotation()">Send Quotation as Email</button>
                    </div>
                </div>
                <div class="box-with-blue-border mt-5 mb-3" v-if="isAggregate && aggregate_costing">
                    <div class="text-secondary pl-5 pr-2 pt-2 pb-2 fw-500" style="background:#fff;">Aggregate Costing</div>
                    <div class="d-flex p-5">
                        <div class="col-lg-6 col-md-6 ml-2" v-for="(aggregate,index) in aggregate_costing.service_tickets" :key="index">
                            <div class="serviceBox mb-2">
                                <div class="d-flex justify-content-between">
                                    <span class="fw-500">Service Ticket Number</span>
                                    <span class="fw-500">Cost</span>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <span class="fw-500 text-secondary">{{aggregate.ticket_number}}</span>
                                    <span class="fw-500 text-secondary">${{aggregate.cost}}</span>
                                </div>
                            </div>
                            <div class="borderBottomBlue"></div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end pb-3">
                        <div class="col-md-3">
                            <div class="serviceBox">
                                <div class="d-flex justify-content-between">
                                    <span>Total Cost</span>
                                    <span>${{aggregate_costing.total_cost}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end mr-5">
                    <button class="btn btn-secondary btn-smm" v-if="general_details.hasOwnProperty('all_product_covered_under_warranty') && !general_details.all_product_covered_under_warranty && !general_details.send_quotation_as_an_email" @click="addQuotation()">Add Quotation</button>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import archieve from '../mixins/archieve.js';
import convert from '../mixins/convert.js';
import { EventBus } from '../eventBus/nav-bar-event.js';
import { SweetModal } from 'sweet-modal-vue'
import Swal from 'sweetalert2';
import setting from '../mixins/setting.js';
export default {
    mixins:[archieve,convert, setting],
    components:{
        SweetModal,
        Swal
    },
    props:['ticket_id','index', "showDetails", "is_ticket_not_found", 'list_loader'],
    data(){
        return{
            ajaxCallinprogress: false,
            success_msg:'',
            warning_msg:'',
            general_details:{
                ticket_template: {
                    template_type: ''
                }
            },
            dynamic_template_data: [],
            template_data:'',
            template_data_SPR:'',
            template_data_SPI:'',
            template_data_SPD:'',
            template_data_TV:'',
            template_data_product: '',
            template_data_SBR:'',
            visible:false,
            attachments:[],
            generic_attachments:[],
            image_attachments:[],
            audio_video_attachments:[],
            isProduct:false,
            isTechnician:false,
            isSPR:false,
            isSPD:false,
            isSPI:false,
            isQuotation:false,
            quotation_details:'',
            isAggregate:false,
            aggregate_costing:'',
            show_priority: false,
            template_type: '',
            show_hide_general_details: true,
            show_hide_tickets_details: true,
            show_hide_multi_details: true,
            show_hide_attachment_details: true,
            priority_of_ticket:[],
        }
    },
    methods:{
        showHideGeneralDetails() {
            this.show_hide_general_details = !this.show_hide_general_details
        },
        showHideTicketsDetails() {
            this.show_hide_tickets_details = !this.show_hide_tickets_details
        },
        showHideMultiDetails() {
            this.show_hide_multi_details = !this.show_hide_multi_details
        },
        showHideAttachmentDetails() {
            this.show_hide_attachment_details = !this.show_hide_attachment_details
        },
        
        previewImage(file) {
            this.$emit('previewImage', file)
            EventBus.$emit('ZindexChangeStart')
        },
        changeStatus(){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to reopen" + ' ' + JSON.stringify(this.general_details.ticket_number) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        ticket_id:this.showDetails.ticket_id
                    }
                    this.confirmReopen(params)
                }
            })
        },
        async confirmReopen(params){
            try {
                let res = await this.reopenTicket(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$emit('UpdateArchiveListOnStatusChange')
                    // this.getDetails()
                    // this.$router.push({ path: "/archievetickets/" }).catch(()=>{});
                    // EventBus.$emit('ReopenedSuccess',this.index)
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
            }
        },
        async sendQuotation(){
            try {
                let params = {
                    ticket_id:this.showDetails.ticket_id
                }
                let res = await this.quotationSendEmail(params)
                this.success_msg = res.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
            }
        },
        distinctAttachments(){
            this.generic_attachments = []
            this.image_attachments = []
            this.audio_video_attachments = []
            this.attachments.forEach((el,index)=>{
                if(el.name.endsWith('.doc') || el.name.endsWith('.docx') || el.name.endsWith('.htm') || el.name.endsWith('.html') || el.name.endsWith('.pdf') || el.name.endsWith('.ppt') || el.name.endsWith('.pptx') || el.name.endsWith('.txt') || el.name.endsWith('.xls') || el.name.endsWith('.xlsx')){
                   this.generic_attachments.push(el)
                }else if(el.name.endsWith('.png') || el.name.endsWith('.jpg') || el.name.endsWith('.svg') || el.name.endsWith('.bmp') || el.name.endsWith('.jpeg') || el.name.endsWith('.gif') || el.name.endsWith('.tiff')){
                   this.image_attachments.push(el)
                }else if(el.name.endsWith('.avi') || el.name.endsWith('.flv') || el.name.endsWith('.mpg') || el.name.endsWith('.mpeg') || el.name.endsWith('.mp3') || el.name.endsWith('.mp4') || el.name.endsWith('.wav') || el.name.endsWith('.wmv')){
                   this.audio_video_attachments.push(el)
                }
            })
        },
        addQuotation(){
            let id = this.showDetails.ticket_id
            this.$router.push({
                path: '/tickets/create/quotation/'+id
            })
        },
        ToggleParts(part){
            if(part.show){
                    part.show = false
            } else {
                    part.show = true
            }
            this.$forceUpdate()
        },
        async getDetails(){
            try {
                this.ajaxCallinprogress = true;
                let params ={
                    ticket_id:this.showDetails.ticket_id,
                    is_web:true
                }
                let res = await this.getArchiveTicketById(params)
                this.ajaxCallinprogress = false;
                this.general_details = res.response.general_details
                if(this.general_details.eisenhower_matrix != null){
                        this.priority_of_ticket = this.general_details.eisenhower_matrix
                    }
                this.template_type = this.general_details.ticket_template.template_type
                this.dynamic_template_data = res.response.template_data[this.general_details.ticket_template.name]
                this.dynamic_template_data.forEach((e) => {
                    e.show = true
                    if(!e.hasOwnProperty('attach_files')){
                        e.attach_files = []
                    }
                })
                this.attachments = this.general_details.attach_files || []
                this.template_data = res.response.template_data;
                this.distinctAttachments()
            } catch (reason) {
													console.log(reason);
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        capitalize(string){
            return string[0].toUpperCase() + string.substring(1);
        },
        async getIsShowPriority() {
            let param = {
                settings_type: ['display_ticket_priorities']
            }
            let data = await this.getAllJobTypes(param);
            this.show_priority = data.response.display_ticket_priorities.display_ticket_priorities;
        },
    },
    created(){
        // EventBus.$on('viewArchiveTickets', (data) => {
        //     this.ticket_id = data.ticket_id
        //     this.prop_ticket_id = data.ticket_id
        //     if(this.ajaxCallinprogress == false) {
        //         this.getDetails();
        //     }
        // })
    },
    watch: {
        'showDetails': function(params){
            this.getDetails();
            this.show_hide_general_details = true
        }
    },
    async mounted(){    
        if(this.showDetails.ticket_id) {
            this.getDetails();
        }
    },
    destroyed(){
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        product_naming_convention(){
            if(this.getGeneralSettings && this.getGeneralSettings.namingConventionOfProducts){
                return this.capitalize(this.getGeneralSettings.namingConventionOfProducts)
            }else{
                return ''
            }
        },
        closed_ticket(){
            return{
                ticket_number:this.general_details.ticket_number,
                company:this.general_details.customer_details.company_name,
                subject:this.general_details.subject,
                author_name:this.general_details.author_name,
                assigned_to:this.general_details.assigned_to,
                description:this.general_details.description,
                ticket_id:this.showDetails.ticket_id
            }
        }
    }
}
</script>
<style scoped>
.btn-width{
    width: 150px !important;
}
.warranty{
    padding: 5px 10px;
    border-radius: 10px;
    background-color:#2dc96f;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}
.out_warranty{
    padding: 5px 10px;
    border-radius: 10px;
    background-color:#f86c65;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}
.serviceBox{
    border: 1px solid #005dae;
    border-radius: 8px;
    padding: 10px 20px;
}
.borderBottomBlue{
    border: 0.5px solid #005dae;
}
.box-new-main{
    border-bottom: 1px solid #00448b;
    margin-bottom: 10px;
}
.box-blue-header-parent {
    background: #005dae;
    position: relative;
    top: -1px;
    margin-left: -1px;
}
.bottom-border{
    border-bottom: 1px solid #cce3fc;
}
.box-blue-header{
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}


.productBox{
    border: 1px solid #005dae;
    border-radius: 8px;
    padding: 10px 20px;
    margin: 15px 0;
    background: #FFF;
}
.box-blue{
    background-color:  #00448b;
    border-radius: 18px;
    padding: 10px 20px;
}
.box-title{
    background-color: #ffffff;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
}
.box-inside{
    background-color:  #ebf4fe;
    border-radius: 18px;
}
.rating{
    background-color: #ffffff;
    border-radius: 5px;
    text-align: center;
}
.signaturebg{
    background-color: #ffffff;
    width: 80%;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.3px #f5a623;
}
.ticket_subject{
    /* width: 250px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; */
    word-break: break-all;
}
.table-hover-none tbody tr:hover{
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    background-color: #fff !important;
}
.product-bg{
    background-color: #ffffff;
   border:1px solid #707070;
   padding: 5px;
   border-radius: 4px;
}
.product-bg-list{
   border-bottom:1px solid #005dae;
}
.tech-file-bg{
    background-color: #f7f8fa;
    border-radius: 4px;
    padding: 10px;
    height: 225px;
}
.rating-counts{
    background-color: #ffffff;
    border: 1px solid #ecf5ff;
    border-radius: 5px;
    min-height: 150px;
    padding: 5px;
    margin-top: 10px;
}
.bottomBorder{
    border-bottom: 1px solid #005dae;
    padding-bottom: 5px;
}
.topBorder{
    border-top: 1px solid #005dae;
    padding-bottom: 5px;
}
.box-with-blue-border {
    border: 15px solid #005dae;
    border-left-width: 10px;
    border-right-width: 10px;
}
._images{
	margin: 5px;
	padding: 5px;
	border-radius: 2.5px;
	box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.2);
	background-color: #f6f8ff;
	width: 177px !important;
    height: 100px !important;
	display: flex;
	flex-direction: column;
}
._images>img{
    height: 90px;
}
.att-background{
    background-color: #F1F3F4;
    margin: 8px;
    border-radius: 8px;
}
.att-img{
    height: 80px;
    /* max-width: 30% */
}
.attachment_name{
    /* width: 380px; */
    /* max-width:260px;
    min-width:185px */
    width: 185px;
}
.w-50{
    width: 50%
}
.w-20{
    width: 20%
}
.description-content{
    word-break: break-all;
    white-space: pre-wrap;
    line-break: anywhere;
}
.details-checks{
    border: 1px solid #0f5dae;
    border-radius: 5px !important;
    padding: 10px;
    margin-top:10px;
    margin: 10px;
}
.infoHeader>.descriptionheader .description-text-header-right img {
    width: 23px;
}
@media screen and (max-width: 1250px) {
    .attachment_name{
        width: 265px;
    }
}
@media (min-width:768px) and (max-width: 1070px){
    .attachment_name{
        width: 150px;
    }
}
@media screen and (max-width: 768px) {
    .col-flex-sm{
        flex-direction: column;
    }
    .w-sm-100{
        width: 100% !important;
    }
}
.view-img-container {
    position: relative;
}

.view-img-container i {
    position: absolute;
    top: 45%;  
    left: 45%;
    transform: translate(-45%, -45%);
    display: none;
}

.view-img-container:hover img {
    opacity: 0.2;    
}

.view-img-container:hover i {
    display: block;
    z-index: 500;
}
.active-matrix{
        color: #fff;
        background-color: #2bb883;
    }
    .eisenhower-button {
            width: 165px;
            font-size: 14px !important;
            height: 35px;
            padding: 0 10px !important;
            border-radius: 6px !important;
            background-color: #00448b !important;
            color: #fff !important;
            font-weight: 500;
        }
        .quadrant{
            width:130px;
            height: 80px;
            display: flex;
            align-items: center;
            padding-left:20px
        }
        .quadrant.top-left{
            border-right: .5px solid #242629;
            border-bottom: .5px solid #242629;
        }
        .quadrant.bottom-left{
            border-right: .5px solid #242629;
            border-top: .5px solid #242629;
        }
        .quadrant.top-right{
            border-left: .5px solid #242629;
            border-bottom: .5px solid #242629;
        }
        .quadrant.bottom-right{
            border-left: .5px solid #242629;
            border-top: .5px solid #242629;
        }
        .header-text {
            color: #242629;
            font-weight: 600;
            text-decoration: underline;
        }

</style>